import React, { useState } from "react";
import { Breadcrumb, Button, Col, Dropdown } from "react-bootstrap";
import { 
  FiHome, FiCalendar, FiFileText, FiChevronUp 
} from "react-icons/fi";
import { BsClockHistory } from "react-icons/bs";

import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link ,useLocation } from "react-router-dom";
import AdminAttendanceReport from "../../../modals/hrm/employee/attendance/adminattendance/AdminAttendanceReport";

export default function AdminAttendanceHeader() {
  const [activeView, setActiveView] = useState("attendance");
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();
    const isAttendance = location.pathname === "/attendance";
  const isCalendar = location.pathname === "/calendar";
  return (
    <div className="page-wrapper">
      
      {/* Breadcrumb */}
      <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        
   
<Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Attendance Admin</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                      <Link  to="/" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                       Attendance

                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6"> Attendance Admin</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>
        {/* RIGHT */}
  <div className="right-section"
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "10px",
    flexWrap: "wrap",
  }}
>
  {/* Toggle Icons */}
   <div className="d-flex align-items-center border rounded p-1 bg-white">
          <Link
            to="/employee-attendance"
            className={`btn btn-sm ${
              location.pathname === "/deals-list"
                ? "btn-orange text-white"
                : "btn-light"
            }`}
          >
               <FiFileText/>
            {/* <FiList /> */}
          </Link>

          <Link
            to="/attendance-admin"
            className={`btn btn-sm ${
              location.pathname === "/deals-grid"
                ? "btn-orange text-white"
                : "btn-light"
            }`}
          >
               <FiCalendar/>
            {/* <FiGrid /> */}
          </Link>
        </div>


  {/* Export Dropdown */}
  <Dropdown>
    <Dropdown.Toggle
      style={{
        background: "#fff",
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "8px 14px",
        display: "flex",
        alignItems: "center",
        color: "#333",
      }}
    >
      <FiFileText style={{ marginRight: "6px" }} />
      Export
      <span style={{ marginLeft: "6px" }}>▾</span>
    </Dropdown.Toggle>

    <Dropdown.Menu align="end">
      <Dropdown.Item>Export as PDF</Dropdown.Item>
      <Dropdown.Item>Export as Excel</Dropdown.Item>
    </Dropdown.Menu>
  </Dropdown>

  {/* Report Button */}
  <Button
    onClick={() => setShowModal(true)}
    style={{
      background: "#ff6a00",
      border: "none",
      borderRadius: "8px",
      padding: "8px 16px",
      display: "flex",
      alignItems: "center",
      color: "#fff",
    }}
  >
    <FiFileText style={{ marginRight: "6px" }} />
    Report
  </Button>
</div>
      </div>

      {/* MODAL */}
      <AdminAttendanceReport
        show={showModal}
        handleClose={() => setShowModal(false)}
      />
<style>
     {

          `
          .page-wrapper {

  background: #f5f6f8;
}

/* ICON BOX */
.icon-box {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 3px;
  background: #fff;
}

.icon-btn {
  border: none;
  background: transparent;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 18px;
}

.icon-btn.active {
  background: #ff6b00;
  color: #fff;
}

/* BUTTONS */
.btn-white {
  background: #fff !important;
  border: 1px solid #ddd !important;
  color: #333 !important;
}




.btn-orange {
  background-color: #f26522;
  border: none;
}

.btn-orange:hover {
  background-color: #e5531a;
}

.attendance-top .label {
  font-size: 13px;
  color: #777;
}

.attendance-stats {
  display: flex;
  justify-content: space-between;
}

.attendance-stats p {
  margin: 0;
  font-size: 14px;
  color: #666;
}

.attendance-stats h5 {
  font-weight: bold;
}

/* DOT COLORS */
.green-dot::before {
  content: "● ";
  color: green;
}
.yellow-dot::before {
  content: "● ";
  color: orange;
}
.blue-dot::before {
  content: "● ";
  color: blue;
}

/* TIMELINE */
.timeline {
  display: flex;
  gap: 6px;
}

.bar {
  height: 25px;
  border-radius: 6px;
  flex: 1;
}

.green {
  background: #16a34a;
}
.yellow {
  background: #facc15;
}
.blue {
  background: #3b82f6;
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .attendance-top,
  .attendance-stats {
    flex-direction: column;
    gap: 10px;
  }
// .right-section {
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start; /* THIS fixes start alignment */
// }
}`
     }
</style>
    </div>
  );
}